<div class="attribute-container" *ngIf="!loading">
  <div class="device-table-container">
    <table #deviceAttributesTable="matSort" mat-table [dataSource]="deviceAttributes" matSort aria-label="attributes">
      <ng-container matColumnDef="attributeNum">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.sensitive.header.num' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.attributeNum}}</td>
      </ng-container>
      <ng-container matColumnDef="attributeName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.sensitive.header.name' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.nameDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="valueDisplayText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.sensitive.header.value' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ showSensitive !== element.attributeNum ? '****' : element.valueDisplayText }}</td>
      </ng-container>
      <ng-container matColumnDef="attributeType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.sensitive.header.type' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.attributeType}}</td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.sensitive.header.last-updated' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">
          {{element.lastUpdatedTimestamp | defaultDate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="sensitiveIcon" color="primary" (mousedown)="showSensitive = element.attributeNum"
            (mouseup)="showSensitive = undefined" (touchstart)="showSensitive = element.attributeNum"
            (touchend)="showSensitive = undefined">
            <mat-icon>{{ showSensitive === element.attributeNum ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="filteredDeviceAttributesColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: filteredDeviceAttributesColumns;"></tr>
    </table>
  </div>
  <mat-paginator #deviceAttributesPaginator [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="!mobile"
    [hidePageSize]="mobile">
  </mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceAttributesGroup="matButtonToggleGroup"
    [(ngModel)]="deviceAttributesColumnsToggle" class="attr-toggle">
    <mat-button-toggle value="attributeNum" class="attr-toggle-item">
      <span>{{'devices.detail.sensitive.header.num' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="attributeName" class="attr-toggle-item">
      <span>{{'devices.detail.sensitive.header.name' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="valueDisplayText" class="attr-toggle-item">
      <span>{{'devices.detail.sensitive.header.value' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="attributeType" class="attr-toggle-item">
      <span>{{'devices.detail.sensitive.header.type' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="attr-toggle-item">
      <span>{{'devices.detail.sensitive.header.last-updated' | translate}}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="loading-container" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
